import { EmbeddedIcon } from "../../icons";
import { embedIconButton } from "../../button";
import { jsx as _jsx } from "react/jsx-runtime";
export function useInputIcon(icon, props = {}) {
  return icon && /*#__PURE__*/_jsx(EmbeddedIcon, { ...props,
    className: "o-ui-input-icon",
    children: icon
  });
}
export function useInputButton(button, isActive, props = {}) {
  return button && isActive && embedIconButton(button, { ...props,
    className: "o-ui-input-button",
    condensed: true,
    shape: "circular",
    variant: "ghost"
  });
}